import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PoiFoodIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.62117 0.96V8.64293H6.09912V6.29222H5.32143L5.31555 3.00513V2.26563L6.62117 0.96ZM5.8376 5.76919H6.09912V2.22155L5.8376 2.48209V5.76919ZM3.23241 3.42812H3.48707V1.335H4.00913V3.95018H3.23241V8.62127H2.70937V3.95018H1.91992V1.335H2.44198V3.42812H2.70937V1.33892H3.23241V3.42812Z"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PoiFoodIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.62117 0.96V8.64293H6.09912V6.29222H5.32143L5.31555 3.00513V2.26563L6.62117 0.96ZM5.8376 5.76919H6.09912V2.22155L5.8376 2.48209V5.76919ZM3.23241 3.42812H3.48707V1.335H4.00913V3.95018H3.23241V8.62127H2.70937V3.95018H1.91992V1.335H2.44198V3.42812H2.70937V1.33892H3.23241V3.42812Z"
            />
        </SvgIcon>
    );
};
